module.exports = __webpack_public_path__ + "static/media/17.c8ee3ec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/17.jpg
// module id = 476
// module chunks = 0